export default __webpack_public_path__ + "static/media/sofrecom.0a6e1e55.png";